/**
 * CSS scrubbing shared by the HTML sanitizer (`lib/sanitize.ts`) and the
 * markdown/hast sanitizer (`lib/sanitize-hast.ts`). Pure string work, no DOM.
 *
 * Removes the CSS constructs that can reach the network or execute code:
 *   - `@import` (loads arbitrary stylesheets)
 *   - `expression(...)`, `-moz-binding`, `behavior:` (legacy code execution)
 *   - `url(...)` unless the target is http(s) or an inline `data:image/…`
 */
const IMPORT_RE = /@import\b[^;]*;?/gi
const EXPRESSION_RE = /expression\s*\(/gi
const BINDING_RE = /(?:-moz-binding|behavior)\s*:[^;}]*;?/gi
const URL_RE = /url\(\s*(['"]?)([^'")]*)\1\s*\)/gi

function isSafeCssUrl(target: string): boolean {
  const t = target.trim().toLowerCase()
  if (t.startsWith('https://') || t.startsWith('http://')) return true
  if (t.startsWith('data:image/')) return true
  // Fragment references (svg gradients/filters: url(#grad)) are local.
  if (t.startsWith('#')) return true
  return false
}

export function scrubCss(css: string): string {
  if (!css) return css
  return css
    .replace(IMPORT_RE, '')
    .replace(EXPRESSION_RE, 'blocked(')
    .replace(BINDING_RE, '')
    .replace(URL_RE, (match, _q, target) => (isSafeCssUrl(target) ? match : 'none'))
}
